"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var csp_square_row_1 = require("./csp_square_row");
var api_request_1 = require("../../api_request");
var comparison_shopping_page_1 = require("./comparison_shopping_page");
var url_helpers_1 = require("../../shared/url_helpers");
var SimilarCSPsRow = /** @class */ (function (_super) {
    tslib_1.__extends(SimilarCSPsRow, _super);
    function SimilarCSPsRow(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { pages: [], loaded: false };
        return _this;
    }
    SimilarCSPsRow.prototype.componentName = function () {
        var strategy = this.props.strategy;
        if (strategy === 'similar') {
            return 'CSPRelatedCsps';
        }
        if (strategy === 'also_purchased') {
            return 'CSPAlsoPurchased';
        }
        if (strategy === 'also_viewed') {
            return ('CSPAlsoViewed');
        }
    };
    SimilarCSPsRow.prototype.trackContext = function () {
        return {
            csp_slug: this.props.slug,
        };
    };
    SimilarCSPsRow.prototype.componentDidMount = function () {
        var _this = this;
        var _a = this.props, slug = _a.slug, strategy = _a.strategy, count = _a.count, table = _a.table;
        var params = { slug: slug, table: table, per_page: count };
        var req = api_request_1.V3.get(url_helpers_1.default.similarCSPsPath(strategy), params);
        req.fail(function (err) { throw err; });
        req.then(function (response) {
            var _a;
            var pages = response
                .comparison_shopping_pages
                .map(function (page) { return new comparison_shopping_page_1.default(page); });
            _this.setState({
                pages: pages,
                loaded: true,
            });
            if (_this.props.setJumplinks) {
                _this.props.setJumplinks((_a = {},
                    _a[_this.props.name] = !!_this.state.pages.length,
                    _a));
            }
        });
    };
    SimilarCSPsRow.prototype.render = function () {
        return (React.createElement("div", { id: this.props.name },
            React.createElement(csp_square_row_1.default, { title: this.props.title, pages: this.state.pages, loaded: this.state.loaded, trackName: this.componentName(), trackContext: this.trackContext(), expectedCount: this.props.count, hideMetadata: this.props.hideMetadata })));
    };
    SimilarCSPsRow.defaultProps = {
        strategy: 'similar',
        count: 4,
    };
    return SimilarCSPsRow;
}(React.Component));
exports.default = SimilarCSPsRow;
//# sourceMappingURL=similar_csps_row.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/csp/similar_csps_row.js
// module id = 1eSH
// module chunks = 20 21